    <div class="banner-container">
        <img src="../../../../assets/apl-afiliacion/imagenes/banner_perfil_afiliador_persona_natural.png"
            alt="afiliacion-onboarding">
    </div>